import React, { useEffect } from "react";
import styled from "styled-components";
import AccountSection from "./Account/AccountSection";
const Wrapper = styled.div`
  .border-CK {
    border: 1px solid #d1d5db;
    border-radius: 12px;
    padding: 24px;
    position: relative;
  }
  .artist-image {
    width: 96px;
    height: 96px;
  }
  .color-1 {
    color: #1f2937;
  }
  /* Утсан дээр засах товч контенттой давхцахгүйн тулд дээд талд зай гаргана */
  @media (max-width: 767px) {
    .border-CK {
      padding: 64px 16px 16px;
    }
  }
`;
const Account = ({
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  isUserCanEdit,
  oneRingRulesAll,
}) => {
  useEffect(() => {
    document.title = "MMusic - Профайл - Дансны тухай";
  }, []);
  return (
    <Wrapper className="flex flex-col gap-4 px-3 py-4 md:px-6 md:py-8">
      <AccountSection
        oneRingRulesAll={oneRingRulesAll}
        isUserCanEdit={isUserCanEdit}
        setCKPopup={setCKPopup}
        setCKPopupType={setCKPopupType}
        setCKPopupMessage={setCKPopupMessage}
      />
    </Wrapper>
  );
};

export default Account;
